import styles from "./styles.module.scss";
import { trayLabels, trayData } from "./mock";
import { Rating } from "@pages/Dashboard/features/Products/Rating";

interface IRecomendationsProps {
  setAddProduct: (value: number) => void;
  back: (value: boolean) => void;
}

export const Recomendations = ({
  setAddProduct,
  back,
}: IRecomendationsProps) => {
  const handleAddProduct = (index: number) => {
    setAddProduct(index);
  };

  const handleBack = () => {
    back(false);
  };

  return (
    <div className={styles.rec}>
      <div className={styles.recTray}>
        <div className={styles.recTray__labels}>
          {trayLabels.map((label, index) => (
            <span key={index} className={styles.recTray__label}>
              {label}
            </span>
          ))}
        </div>
        <div className={styles.recTray__list}>
          {trayData.map((item, index) => (
            <div key={index} className={styles.recTray__item}>
              <span className={styles.recTray__itemTitle}>{item.title}</span>
              <span>{item.demand}</span>
              <span>{item.competition}</span>
              <span>{item.trendy}</span>
              <span>{item.trendyScore}</span>
              <span>{item.search}</span>
              <span>{item.top}</span>
              <span>{item.roi}</span>
              <Rating rating={item.score} starSize="sm" />
              <button
                className={styles.add}
                onClick={() => handleAddProduct(index)}
              >
                Add
              </button>
            </div>
          ))}
        </div>
      </div>
      <button className={styles.back} onClick={handleBack}>
        Back
      </button>
    </div>
  );
};
